import { Box, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import { KAYTTO_IKA_ID_50V, KAYTTO_IKA_ID_100V } from "src/utils/quote/quoteConstants";
import { useT } from "src/i18n";

// Shared 50v / 100v "Suunnitteluikä" toggle used in StepConcrete (manual mode)
// and SpecGuideResult (inside the avustin modal). `value` is a betoniKayttoIka
// FK (1=50v default, 2=100v); falls back to 50v when null/empty so the toggle
// always has a visible selection. `onChange(nextValue)` is only invoked for a
// non-null pick (MUI ToggleButtonGroup fires null when the user clicks the
// already-selected option — that's swallowed here).
export default function KayttoIkaToggle({ value, onChange, label, sx }) {
    const theme = useTheme();
    const amber = theme.custom?.wizard?.amber ?? "#E8893B";
    const t = useT();
    const resolvedLabel = label ?? t("wizard.shared.suunnitteluikaLabel");

    return (
        <Box sx={sx}>
            <Box sx={{ fontSize: 13, color: "text.secondary", mb: 0.75 }}>{resolvedLabel}</Box>
            <ToggleButtonGroup
                size="small"
                exclusive
                value={value ?? KAYTTO_IKA_ID_50V}
                onChange={(_, v) => v != null && onChange(v)}
                sx={{
                    "& .MuiToggleButton-root": {
                        textTransform: "none",
                        px: 2,
                        borderColor: `${amber}40`,
                    },
                    "& .Mui-selected": {
                        bgcolor: `${amber}1f`,
                        color: amber,
                        borderColor: `${amber}80`,
                        "&:hover": { bgcolor: `${amber}2a` },
                    },
                }}
            >
                <ToggleButton value={KAYTTO_IKA_ID_50V}>
                    {t("wizard.shared.years50")}
                    <Box
                        component="span"
                        sx={{
                            ml: 0.75,
                            fontSize: 11,
                            opacity: 0.85,
                            fontWeight: 400,
                            letterSpacing: "0.06em",
                        }}
                    >
                        {t("wizard.kayttoIkaToggle.defaultBadge")}
                    </Box>
                </ToggleButton>
                <ToggleButton value={KAYTTO_IKA_ID_100V}>{t("wizard.shared.years100")}</ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
}
